module.exports = __webpack_public_path__ + "img/6_122.e79e3685.png";